import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

//components
import { Planner } from "../components/planner/planner";
import { LoaderMUI } from "../assets/global/loader/loader-mui";
import { AlertMessage } from "../assets/global/alert/alert-message";
import { usePlannerContext } from "../services/context/planner-context";
import {
  fetchBuildings,
  fetchBuildingTypes,
  fetchConnections,
  fetchConnectionTypes,
} from "../services/api/planner-api";
import { fetchProperty } from "../services/api/site-settings-api";

//images

//style

export const PlannerPage = () => {
  const { projectId } = useParams();
  const {
    nodes,
    setNodes,
    edges,
    setEdges,
    connectionTypes,
    setConnectionTypes,
    setProperty,
    buildingsTypes,
    setBuildingsTypes,
  } = usePlannerContext();

  const [buildings, setBuildings] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const transformBuildingToNode = (fetchedBuildings, fetchedBuildingTypes) => {
    return fetchedBuildings.map((building) => {
      const { buildingMiroPosition, buildingType, id } = building;
      const area = fetchedBuildingTypes.find((b) => b.id === buildingType);
      return {
        id: buildingMiroPosition.id,
        type: buildingMiroPosition.type,
        position: buildingMiroPosition.position,
        deletable: false,
        data: {
          building,
          typeId: buildingType,
          type: area.node_name,
          typeName: area.display_name,
          color: area.color,
          buildingId: id,
        },
      };
    });
  };

  useEffect(() => {
    if (!projectId) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        // Run all API calls concurrently.
        const [
          fetchedBuildingTypes,
          fetchedConnectionTypes,
          fetchedBuildings,
          fetchedEdges,
          fetchedProperty,
        ] = await Promise.all([
          fetchBuildingTypes(),
          fetchConnectionTypes(),
          fetchBuildings(projectId),
          fetchConnections(projectId),
          fetchProperty(projectId),
        ]);

        const buildingTypesFiltered = fetchedBuildingTypes
          .filter((item) => item.displayFrontend)
          .sort((a, b) => a.order - b.order);

        const connectionTypesFiltered = fetchedConnectionTypes
          .filter((item) => item.displayFrontend)
          .sort((a, b) => a.order - b.order);

        const buildingsNodes = transformBuildingToNode(
          fetchedBuildings,
          fetchedBuildingTypes
        );

        const connectionsEdges = fetchedEdges.map((connection) => ({
          ...connection.dataStr,
          id: connection.id,
        }));

        setBuildingsTypes(buildingTypesFiltered);
        setConnectionTypes(connectionTypesFiltered);
        setBuildings(fetchedBuildings);
        setNodes(buildingsNodes);
        setEdges(connectionsEdges);
        setProperty(fetchedProperty && Object.hasOwn(fetchedProperty, "geodata") ? fetchedProperty : null);
      } catch (err) {
        console.error("Error fetching planner data:", err);
        const message =
          err.response?.data?.message || err.message || "Error fetching data";
        setError(message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [projectId, setNodes, setEdges, setConnectionTypes]);

  return (
    <>
      {/* Loader */}
      {loading && <LoaderMUI withBackdrop={true} />}

      {/* Error Alert */}
      {error && <AlertMessage message={error} type="error" />}

      <Box sx={{ width: "100%", height: "100%" }}>
        {buildingsTypes && buildings && connectionTypes && edges && <Planner />}
      </Box>
    </>
  );
};
